module.exports = __webpack_public_path__ + "img/transfer-service.ac90a7e4.jpg";